
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelQuality from "@/views/评测管理/model/DZModelQuality";
import DZModelDicConfig from "@/model/DZModelDicConfig";

@Component
export default class Quality extends Vue{

  @Prop() data;

  @Prop() dic;

  @Watch("data")
  watchData(value: any, oldValue: string){
    if(value){
      this.m_quality = value
    }
  }

  flag = true
  handle_edit(){
    this.flag = !this.flag
  }

  m_quality = new DZModelQuality();

  formData = {
    soilFertility:[],
    thickness:[],
    salinization:[],
    soilTexture:[],
    soilPh:[],
    organicContent:[],
    groundwaterDepth:[]
  }

  arr = ['soilFertility', 'thickness', 'salinization',
  'soilTexture', 'soilPh', 'organicContent', 'groundwaterDepth']

  dic_config = new DZModelDicConfig();

  @Watch("dic")
  watchDic(value: any, oldValue: string) {
    if(value){
      let idList = []
      this.arr.forEach( a =>{
        idList.push(this.dic_config.get(a))
      })
      value.forEach( d =>{
        let index = idList.indexOf(d.typeId)
        if (index != -1) {
          this.formData[this.arr[index]] = d.dicList
        }
      })
      this.$forceUpdate()
    }
  }

  handle_submit(){
    this.$emit('ny_submit_quality', this.m_quality)
    this.handle_edit()
  }
}
